import React from "react";
import { MessageCircle, Search, Bike } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageCircle,
    title: "WhatsApp us",
    body: "Share your request with us — a quick message or voice note works.",
  },
  {
    n: "02",
    icon: Search,
    title: "We check nearby",
    body: "We find it at a nearby shop and confirm availability and price with you.",
  },
  {
    n: "03",
    icon: Bike,
    title: "We deliver",
    body: "Once confirmed, we pick it up and bring it to your doorstep.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-16 md:py-24 lg:py-28 bg-slate-900 text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-[0.08]" aria-hidden="true" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[420px] w-[900px] rounded-full bg-[#84cc15]/15 blur-3xl" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.2em] text-[#84cc15] font-semibold uppercase">
            How it works
          </div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1]">
            Three steps. Zero friction.
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg leading-relaxed">
            Just tell us what you need, we’ll handle the rest.
          </p>
        </div>

        <div className="mt-12 lg:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative">
          {/* Connecting line on desktop */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" aria-hidden="true" />

          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`how-step-${i + 1}`}
              className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 lg:p-7 hover:bg-white/[0.08] transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="h-14 w-14 rounded-2xl bg-[#84cc15] flex items-center justify-center">
                  <s.icon className="h-6 w-6 text-slate-900" strokeWidth={2} />
                </div>
                <div className="font-display text-5xl font-bold text-white/10">{s.n}</div>
              </div>
              <h3 className="mt-6 text-xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
